import React, { FC } from 'react';

import { ACModal } from 'shared/components';

interface NotificationModalProps {
  open: boolean;
  onClose: () => void;
}

export const NotificationModal: FC<NotificationModalProps> = ({ open, onClose }) => {
  return (
    <ACModal
      title="Your quote has expired"
      content={
        <div className="ta-tooltip-container">
          Your quote has expired. Click below to view your updated quote.
        </div>
      }
      showCloseButton={false}
      showDivider={true}
      open={open}
      onClose={onClose}
      buttonText="View quote"
    />
  );
};
